import React, { useEffect, useMemo, useState } from 'react'
import { db } from '../../firebase'
import {
  arrayRemove,
  collection,
  doc,
  getDoc,
  onSnapshot,
  updateDoc
} from 'firebase/firestore'
import toast from 'react-hot-toast'
import { Pin, X } from 'lucide-react'
import { MessageItem } from '.'
// import { MessageItem } from './MessageItem'

const PinnedMessagesList = ({ channelId, onClose }) => {
  const [pinnedMessages, setPinnedMessages] = useState([])
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!channelId) return

    const unsubscribeChannel = onSnapshot(
      doc(db, 'chats', channelId),
      (doc) => {
        if (doc.exists()) {
          setPinnedMessages(doc.data().pinnedMessages || [])
        }
      }
    )

    const unsubscribeMessages = onSnapshot(
      collection(db, 'chats', channelId, 'messages'),
      (snapshot) => {
        const messageData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }))
        setMessages(messageData)
        setLoading(false)
      }
    )

    return () => {
      unsubscribeChannel()
      unsubscribeMessages()
    }
  }, [channelId])

  const handleUnpin = async (pinnedMessageObj) => {
    try {
      const channelRef = doc(db, 'chats', channelId);
      const channelSnap = await getDoc(channelRef);

      if (channelSnap.exists()) {
        const currentPinned = channelSnap.data().pinnedMessages || [];
        // Remove the specific pinned message object
        const updatedPinnedMessages = currentPinned.filter(msg =>
          msg.messageId !== pinnedMessageObj.messageId
        );

        await updateDoc(channelRef, {
          pinnedMessages: updatedPinnedMessages,
          lastUpdatedAt: new Date().toISOString(),
        });
        toast.success('Message unpinned');
      }
    } catch (error) {
      console.error('Failed to unpin message:', error);
      toast.error('Failed to unpin message');
    }
  }

  const pinnedMessagesData = useMemo(() => {
    // Since pinnedMessages is now an array of objects with messageId,
    // we need to find the actual message objects from the messages collection
    return pinnedMessages
      .map((pinnedMsg) => {
        // Find the actual message object that matches the messageId
        const message = messages.find((msg) => msg.id === pinnedMsg.messageId);
        if (message) {
          // Include the pinned metadata with the message
          return {
            ...message,
            pinnedBy: pinnedMsg.pinnedBy,
            pinnedAt: pinnedMsg.pinnedAt
          };
        }
        return null;
      })
      .filter(Boolean);
  }, [pinnedMessages, messages]);

  return (
    <div className=' space-y-4 bg-gray-50 min-h-full pinned-messages-list overflow-scroll'>
      <div className='flex justify-between items-center p-2'>
        <h2 className='text-lg font-semibold text-gray-900'>Pinned Messages</h2>
        <button onClick={onClose} className='text-gray-400 hover:text-gray-600 cursor-pointer'>
          <X className='w-5 h-5' />
        </button>
      </div>
      <div className='p-2'>
        {loading ? (
          <div className='flex justify-center py-8'>
            <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500'></div>
          </div>
        ) : pinnedMessagesData.length === 0 ? (
          <div className='text-center text-gray-500 py-12'>
            <Pin className='w-12 h-12 text-gray-300 mx-auto mb-4' />
            <p>No pinned messages yet.</p>
          </div>
        ) : (
          <div className='space-y-4'>
            <div className='bg-white p-4 rounded-lg border border-gray-200 '>
              {pinnedMessagesData.map((message) => (
                <div className='relative group ' key={message.id}>
                  <div className="mb-2 text-sm text-gray-500">
                    Pinned by {message.pinnedBy}
                  </div>
                  <MessageItem
                    message={message}
                    onReply={() => { }}
                    onAddReaction={() => { }}
                    onContextMenu={() => { }}
                    onViewProfile={() => { }}
                    showTimestamp={true}
                  />
                  <button
                    onClick={() => handleUnpin(message)}
                    className='absolute top-0 -right-1 p-1 bg-gray-100 rounded-full opacity-0 group-hover:opacity-100 transition-opacity'
                    title='Unpin message'>
                    <X className='w-3 h-3 text-gray-500' />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PinnedMessagesList